<script>
import { Money } from "v-money";

export default {
  props: {
    inputID: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      price: this.value,
      money: {
        prefix: "",
        suffix: " m²",
        thousands: ",",
        decimal: ".",
        precision: 0,
        masked: false,
      },
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        // console.log(value);
        this.$emit("input", value);
      },
    },
  },
  components: {
    Money,
  },
};
</script>

<template>
  <b-field class="field-metric" :label="label" :label-for="inputID">
    <div class="control is-clearfix">
      <money v-model="model" v-bind="money" class="input" :id="inputID" />
    </div>
  </b-field>
</template>
